import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/yeehaa/Documents/offcourse/projects/offcourse-studio/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js')["default"];

var scope_1 = require('/Users/yeehaa/Documents/offcourse/projects/offcourse-studio/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a14b6db43c61c96f9b894a2e122765fd.js')["default"];

export default Object.assign({}, scope_0, scope_1);